import * as GlobalSearchService from "./GlobalSearch";

export default {
  GlobalSearchService,
};
